module.exports = __webpack_public_path__ + "static/media/logo-POSpulse.af838323.png";